<template>
  <div class="main-index">
    <site-header />
    <div v-if="false" class="header">
      <div class="login" v-show="userInfo===''" data-track-text="H5阅读登录" aria-label="H5阅读登录" @click="toPath('/h5/login')">
        登录
      </div>
      <div class="login" v-show="userInfo!==''">
        <el-dropdown @command="logOut" v-if="showloginOut"
                     style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
            <span v-show="userInfo!==''" class="title_hide"
                  style="overflow-x: hidden;text-overflow: ellipsis;width: 100px;white-space: nowrap;">
              {{ userInfo }}
            </span>
          <el-dropdown-menu v-if="showloginOut" slot="dropdown">
            <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">充值中心</span>
            </el-dropdown-item>
            <el-dropdown-item command="toAccount" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人设置</span>
            </el-dropdown-item>
            <el-dropdown-item command="toOrder" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">订单详情</span>
            </el-dropdown-item>
            <el-dropdown-item style="z-index: 1;font-weight: 800">
              <span style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span data-track-text="个人中心" aria-label="个人中心" @click="toCenter">
            <img v-if="userType==='0'" class="user-img" src="../assets/img/person_no.png" alt="">
            <img v-if="userType==='1'" class="user-img" src="../assets/img/child_no.png" alt="">
            <img v-if="userType==='2'" class="user-img" src="../assets/img/roaming_no.png" alt="">
          </span>
      </div>
      <div v-if="groupUserInfo==='机构登录'" class="login" data-track-text="H5阅读机构登录" aria-label="H5阅读机构登录" @click="toPath('/h5/login')">
        <span>机构登录</span>
      </div>
      <div v-if="groupUserInfo!=='机构登录'"
           style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="login">
        <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                     style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
          <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="title_hide">{{
              groupUserInfo
            }}</span>
          <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
            <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                              style="z-index: 1;font-weight: 800">
                <span style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                    item.name
                  }}</span>
              <span
                  style="margin-left:10px; font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                  v-if="!item.isIpScore">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select" style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
        在线阅读
      </div>
      <div class="select">
        <div data-track-text="展开阅读导航" aria-label="展开阅读导航" @click="showSelect=!showSelect" class="select-option">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-show="showSelect" class="selected">
        <div data-track-text="H5阅读导航首页" aria-label="H5阅读导航首页" @click="toPath('/index')">首页</div>
        <div data-track-text="H5阅读导航立即翻译" aria-label="H5阅读导航立即翻译" @click="toPath('/translate')">立即翻译</div>
        <div data-track-text="H5阅读导航人工翻译" aria-label="H5阅读导航人工翻译" @click="toPath('/trans-pro')" v-if="isShowTransPro">人工翻译</div>
        <div data-track-text="H5阅读导航PDF转换" aria-label="H5阅读导航PDF转换" @click="toPath('/convert')">PDF转换</div>
        <div data-track-text="H5阅读导航历史文档" aria-label="H5阅读导航历史文档" @click="toPath('/list')">历史文档</div>
      </div>
    </div>
    <div class="read-main-title">
      <div>{{ title }}</div>
    </div>
    <div class="read-main-lang">
      <div class="read-main-lang-content">
        <div>{{ language }}</div>
        <div data-track-text="H5阅读下载文档" aria-label="H5阅读下载文档" @click="downloadFile">下载文档</div>
      </div>
    </div>
    <div class="read-main">
      <div v-show="activeNum===0||activeNum===1" :style="activeNum===1?'height: 913px;':''" class="read-main-org" ref="original" @scroll="scrollTop">
        <pdf
            ref="pdf"
            @num-pages="pageTotalNum=$event"
            @link-clicked="page = $event"
            v-for="i in originalnumPages"
            :key="i"
            :src="originalsrc"
            :page="i"
            style="display: inline-block; width: 100%"
        ></pdf>
      </div>
      <div style="margin-bottom: 5px">
        <img v-show="activeNum===0" @click="activeNum=1" data-track-text="展开原文" aria-label="展开原文" width="61" src="../assets/H5/open.png"/>
        <img v-show="activeNum===1" @click="activeNum=0" data-track-text="收起原文" aria-label="收起原文" width="61" src="../assets/H5/open.png"
             style="transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);"/>
      </div>
      <div v-show="activeNum===0||activeNum===2" :style="activeNum===2?'height: 913px;':''" class="read-main-tra" ref="translate">
        <pdf
            ref="pdf"
            @num-pages="pageTotalNum=$event"
            @link-clicked="page = $event"
            v-for="i in translatesrcnumPages"
            :key="i"
            :src="translatesrc"
            :page="i"
            style="display: inline-block; width: 100%"
        ></pdf>
      </div>
      <div style="margin-bottom: 5px">
        <img v-show="activeNum===0" @click="activeNum=2" data-track-text="展开译文" aria-label="展开译文" width="61" src="../assets/H5/open.png"/>
        <img v-show="activeNum===2" @click="activeNum=0" data-track-text="收起译文" aria-label="收起译文" width="61" src="../assets/H5/open.png"
        style="transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);"/>
      </div>
      <div>
        <img v-show="activeNum!==0" @click="activeNum===1?activeNum=2:activeNum=1" data-track-text="切换原文译文" aria-label="切换原文译文" src="../assets/H5/other.png" width="705"/>
      </div>
    </div>
    <div v-if="false" class="main-foot" style="flex-flow: column">
      <div>
        © 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All
        rights reserved. 京公网安备 11011402010815号
      </div>
      <div style="margin-top: 10px">
        <a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
        <span style="margin-left: 15px">联系电话：010-80755328</span>
      </div>
    </div>
    <site-footer />
    <el-dialog
        :title="downloadTitle"
        :visible.sync="centerDialogVisible"
        width="555px"
        center>
      <div :class="downloadClass">
        <div v-show="isDownload" class="read-download-heading" style="margin-bottom: 40px;    text-align: left;
    font-size: 18px;
     font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #666666;
    margin-left: 70px;">译文下载
        </div>
        <div v-show="isDownload" class="read-download-formats" style="margin: 0 44.5px;">
          <div class="down-type">
            <img src="../assets/doc.png" alt="" data-track-text="选择DOC格式" aria-label="选择DOC格式" style="width: 54px;height: 68px" @click="radio='doc'">
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0;
    margin-top: 9px;text-align: center;">doc
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/docx.png" alt="" data-track-text="选择DOCX格式" aria-label="选择DOCX格式" style="width: 54px;height: 68px" @click="radio='docx'">
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">docx
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/pdf.png" alt="" data-track-text="选择PDF格式" aria-label="选择PDF格式" style="width: 54px;height: 68px" @click="radio='pdf'">
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">pdf
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/txt.png" alt="" data-track-text="选择TXT格式" aria-label="选择TXT格式" style="width: 54px;height: 68px" @click="radio='txt'">
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">txt
            </div>
          </div>
        </div>
        <div v-show="isDownload" class="read-download-subheading" style="width: 115px;
          text-align: left;
          font-size: 18px;
           font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #666666;
          margin-left: 70px;
          margin-top: 120px;">双语对照下载
        </div>
        <div v-show="isDownload" class="read-download-formats" style="margin: 0px 44.5px;">
          <div class="down-type">
            <img src="../assets/docx.png" alt="" data-track-text="选择原文批注DOCX" aria-label="选择原文批注DOCX" style="width: 54px;height: 68px" @click="radio='commentsone'">
            <el-radio v-model="radio" label="commentsone"></el-radio>
            <div style="line-height: 0;
    margin-top: 9px;">原文做批注
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/docx.png" alt="" data-track-text="选择译文批注DOCX" aria-label="选择译文批注DOCX" style="width: 54px;height: 68px" @click="radio='commentstwo'">
            <el-radio v-model="radio" label="commentstwo"></el-radio>
            <div style="line-height: 0;
    margin-top: 9px;">译文做批注
            </div>
          </div>
        </div>
        <div v-show="isDownload" class="read-download-actions" style="position: absolute; left: 50%; top: 85%; transform: translate(-50%, 0px);">
          <el-button class="el-button--primarys" type="primary" data-track-text="H5阅读确认下载文档" aria-label="H5阅读确认下载文档" style="margin-right: 11px" :loading="downloadDocLoad"
                     @click="downloadDoc">下 载
          </el-button>
          <el-button class="el-button--defaults" data-track-text="H5阅读取消下载文档" aria-label="H5阅读取消下载文档" @click="centerDialogVisible = false">取 消</el-button>
        </div>
        <div v-show="!isDownload" class="read-download-progress-state">
          <div style="line-height: 0;text-align: center"><img src="../assets/downloadjindu.png" alt=""
                                                              style="height: 166px;width: 330px"></div>
          <div style="
            text-align: center;
            width: 360px;
            height: 48px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgb(52, 52, 52);
            line-height: 30px;
            margin-left: 50%;
            transform: translate(-50%, 0px);
            margin-bottom: 42px;
            "><span>{{ downloadMessage }}</span></div>
          <div style="position: absolute;left: 50%;transform: translate(-50%,0)">
            <el-progress :color="customColorDownload" style="width: 395px;" id="test" :text-inside="true"
                         :stroke-width="28" :percentage="downloadPercentage"></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="downloadTitle"
        :visible.sync="centerDialogVisiblePro"
        width="555px"
        center>
      <div :class="downloadClass" style="height: 270px;">
        <div v-show="isDownload" class="read-download-heading" style="margin-bottom: 40px;    text-align: left;
    font-size: 18px;
     font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #666666;
    margin-left: 70px;">译文下载
        </div>
        <div v-show="isDownload" class="read-download-formats" style="margin: 0 44.5px;">
          <div class="down-type">
            <img src="../assets/doc.png" alt="" data-track-text="选择DOC格式" aria-label="选择DOC格式" style="width: 54px;height: 68px" @click="radio='doc'">
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0;
    margin-top: 9px;text-align: center;">doc
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/docx.png" alt="" data-track-text="选择DOCX格式" aria-label="选择DOCX格式" style="width: 54px;height: 68px" @click="radio='docx'">
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">docx
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/pdf.png" alt="" data-track-text="选择PDF格式" aria-label="选择PDF格式" style="width: 54px;height: 68px" @click="radio='pdf'">
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">pdf
            </div>
          </div>
          <div class="down-type">
            <img src="../assets/txt.png" alt="" data-track-text="选择TXT格式" aria-label="选择TXT格式" style="width: 54px;height: 68px" @click="radio='txt'">
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="text-align: center;line-height: 0;
    margin-top: 9px;">txt
            </div>
          </div>
        </div>
        <div v-show="isDownload" class="read-download-actions" style="position: absolute; left: 50%; top: 85%; transform: translate(-50%, -15px);">
          <el-button class="el-button--primarys" type="primary" data-track-text="H5阅读确认下载专业文档" aria-label="H5阅读确认下载专业文档" style="margin-right: 11px" :loading="downloadDocLoad"
                     @click="downloadDoc">下 载
          </el-button>
          <el-button class="el-button--defaults" data-track-text="H5阅读取消下载专业文档" aria-label="H5阅读取消下载专业文档" @click="centerDialogVisiblePro = false">取 消</el-button>
        </div>
        <div v-show="!isDownload" class="read-download-progress-state">
          <div style="line-height: 0;text-align: center"><img src="../assets/downloadjindu.png" alt=""
                                                              style="height: 166px;width: 330px"></div>
          <div style="
            text-align: center;
            width: 360px;
            height: 48px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgb(52, 52, 52);
            line-height: 30px;
            margin-left: 50%;
            transform: translate(-50%, 0px);
            margin-bottom: 42px;
            "><span>{{ downloadMessage }}</span></div>
          <div style="position: absolute;left: 50%;transform: translate(-50%,0)">
            <el-progress :color="customColorDownload" style="width: 395px;" id="test" :text-inside="true"
                         :stroke-width="28" :percentage="downloadPercentage"></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {outRequest, userPowerRequest, userStatusRequest} from "@/tools/api/auth-api";
import {Base64} from "js-base64";
import {checkRoamingRequest, documentRequest, readingFileRequest, uploadTipRequest} from "@/tools/api/translate-api";
import pdf from 'vue-pdf'
import {Loading} from "element-ui";
import lanuages from "../../language.json";
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";

export default {
  name: "NewRead",
  components: {
    pdf,
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      activeNum:0,
      loading: null,
      customColorDownload: '#1b5ea4 !important',
      downloadMessage: '下载大型文档或转换文档时，需等待时间较长请您耐心等待！',
      downloadClass: 'downloadClass',
      downloadStatus: '',
      downloadPercentage: 0,
      isDownload: true,
      downloadTitle: '确定下载该文件的译文版本吗？',
      centertab: "center-tab",
      downloadDocLoad: false,
      radio: 'pdf',
      centerDialogVisible: false,
      centerDialogVisiblePro: false,
      showOriginalOnly: false,
      showTranslateOnly: false,
      showOriginal: true,
      showTranslate: true,
      // 全屏/不全屏
      isFullscreen: false,
      language: "",
      title: "",
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      originalsrc: undefined,
      translatesrc: undefined,
      originalnumPages: undefined,
      translatesrcnumPages: undefined,
      downloadTimer: '',
      scroll: '',
      status: false,
      original: "original",
      translate: "translate",
      onlyorig: "onlyorig",
      onlytran: "onlytran",
      isOK: false,

      showSelect: false,
      hasH5: false,
      hasAwarded: true,
      payCenterDialogVisible2: false,
      payCenterDialogVisible: false,
      qrcodeUrl: '',
      groupUserInfos: [],
      userInfo: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      showRoaming: false,
      groupUserInfo: '',
      userId: '',
      userType: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowInRoaming: false,
      isShowTransPro: false,
      timer: undefined
    }
  },
  watch: {
    pageNum(val) {
      if (val <= 0) {
        val = 1;
      }
      if (val > this.pageTotalNum) {
        val = this.pageTotalNum;
      }
      if (!parseInt(val)) {
        return
      }
      this.$refs['translate'].scrollTop = (val - 1) * this.$refs['pdf'][val - 1].$refs['canvas'].height
      this.$refs['original'].scrollTop = (val - 1) * this.$refs['pdf'][val - 1].$refs['canvas'].height
    },
    isOK(val) {
      if (val) {
        this.initPdf();
      }
    },
    payCenterDialogVisible(val) {
      if (val) {
        this.timer = setTimeout(this.payCenterDialogVisibleClose, 5000);
      }
    },
  },
  created() {
    this.showTip()
    this.getUploadTip()
    const that = this;
    window.addEventListener('message', function (e) {
      if (e.data.data === "params") {
        if (that.hasH5) {
          that.$router.push('/h5/login')
          return
        }
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      }
      if (e.data.data === "register") {
        that.openTry()
      }
      if (e.data.data === "close") {
        layer.closeAll()
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true
      }
    })
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.groupUserInfo = "";
        this.showRoaming = false;
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false
    });
    this.loading = Loading.service({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  },
  mounted() {
    const that = this;
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        that.$router.push("/h5/login")
        return
      }
      authServiceClient.checkUserPower(userPowerRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          that.isOK = true
          return;
        }
        that.$router.push("/h5/login")
      }).catch(err => {
        that.$router.push("/h5/login")
      })
    }).catch(err => {
      localStorage.removeItem("token");
      localStorage.removeItem("auth-context");
      that.$router.push("/h5/login")
    });
  },
  methods: {
    base64ToBlob(code, type) {
      let bstr = atob(code)
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: type});
    },
    downloadDoc() {
      this.downloadDocLoad = true;
      let request = readingFileRequest;
      request.setId(this.$route.params.documentId);
      request.setType(this.radio);
      const that = this;
      const TOKEN_KEY = 'token';
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = 'downloadClass2';
      this.downloadTitle = '';
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.customColorDownload = '#1b5ea4';
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = '#38cb1c';
          this.downloadMessage = '下载完成'
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on('data', (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文件失败'
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on('end', (end) => {
        let aLink = document.createElement('a');
        let blob = this.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
        that.downloadPercentage = 99;
      });
      stream.on('error', (err) => {
        clearInterval(this.downloadTimer);
        this.isDownload = true;
        this.downloadDocLoad = false;
        this.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        if (err && err.code === 5) {
          that.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文档失败，请稍后再试！'
          })
        }
      });
    },
    downloadFile() {
      this.downloadTitle = '确定下载该文件的译文版本吗？';
      this.downloadClass = 'downloadClass';
      this.downloadStatus = '';
      this.downloadMessage = '下载大型文档或转换文档时，需等待时间较长请您耐心等待！';
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.radio = this.title.substring(this.title.lastIndexOf(".") + 1);
      let id = this.$route.params.documentId
      if (id.indexOf("-") > 0) {
        this.centerDialogVisible = true;
      } else {
        this.centerDialogVisiblePro = true;
      }
    },
    scrollTop(event) {
      this.$refs['translate'].scrollTop = event.srcElement.scrollTop;
    },
    getChineseName(lanuage) {
      let label = lanuage;
      lanuages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    initPdf() {
      const that = this;
      if (localStorage.getItem('auth-context') &&
          localStorage.getItem('token')) {
        const id = that.$route.params.documentId;
        let request = documentRequest;
        request.setDocId(id);
        let status1 = false;
        let status2 = false;
        const TOKEN_KEY = 'token';
        translateServiceClient.getDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          that.title = res.getTitle();
          that.pageTotalNum = res.getCount();
          const to = that.getChineseName(res.getLanguageTo());
          const from = that.getChineseName(res.getLanguageFrom());
          that.language = "语言：" + from + "→" + to;
          that.originalsrc = pdf.createLoadingTask(res.getOriginalUrl());
          that.originalsrc.promise.then(pdf => {
            that.originalnumPages = pdf.numPages;
            status1 = true;
          });
          that.translatesrc = pdf.createLoadingTask(res.getTranslateUrl());
          that.translatesrc.promise.then(pdf => {
            that.translatesrcnumPages = pdf.numPages;
            status2 = true;
          });
          that.timer = setInterval(function () {
            if (status2 && status1) {
              that.loading.close();
              that.status = true;
              clearInterval(that.timer)
            }
          }, 100)
        }).catch(err => {
          if (err && err.code === 5) {
            that.$router.push("/index")
            window.parent.postMessage({
              data: "params"
            }, '*');
          }
        });
      }
    },
    //是移动端返回true,否则false
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches
    },
    payCenterDialogVisible2Close() {
      this.payCenterDialogVisible2 = false
      localStorage.setItem("payCenterDialogVisible2", false)
    },
    payCenterDialogVisibleClose() {
      this.payCenterDialogVisible = false
      localStorage.setItem("payCenterDialogVisible", false)
      let payCenterDialogVisible2 = localStorage.getItem("payCenterDialogVisible2")
      this.payCenterDialogVisible2 = !(payCenterDialogVisible2 !== undefined && payCenterDialogVisible2 !== null);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowInRoaming = res.getIsRoaming();
        this.isShowTransPro = res.getIsTransPro();
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
      });
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    showTip() {
      let hasAwarded = localStorage.getItem("hasAwarded")
      if (hasAwarded !== undefined && hasAwarded !== null) {
        this.hasAwarded = false;
      }
      let payCenterDialogVisible = localStorage.getItem("payCenterDialogVisible")
      let payCenterDialogVisible2 = localStorage.getItem("payCenterDialogVisible2")
      this.payCenterDialogVisible = !(payCenterDialogVisible !== undefined && payCenterDialogVisible !== null);
      if (!this.payCenterDialogVisible) {
        this.payCenterDialogVisible2 = !(payCenterDialogVisible2 !== undefined && payCenterDialogVisible2 !== null);
      }
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    toLogin() {
      const TOKEN_KEY = 'token';
      authServiceClient.getUserStatus(userStatusRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (!res.getStatus()) {
          localStorage.removeItem("token")
          localStorage.removeItem("auth-context")
          window.parent.postMessage({
            data: "register"
          }, '*');
          return;
        }
        if (localStorage.getItem('auth-context') &&
            localStorage.getItem('token')) {
          authServiceClient.checkUserPower(userPowerRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (res.getStatus()) {
              this.$router.push('/translate')
              return;
            }
            this.$message({
              center: true,
              type: 'error',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            window.parent.postMessage({
              data: "params"
            }, '*');
          }).catch(err => {
            window.parent.postMessage({
              data: "params"
            }, '*');
          })
        }
      }).catch(err => {
        window.parent.postMessage({
          data: "register"
        }, '*');
      });
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    closeAwarded() {
      this.hasAwarded = false
      localStorage.setItem("hasAwarded", false)
    },
    toPath(url) {
      this.showSelect = false
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            if (this.hasH5) {
              this.$router.push('/h5/login')
              return
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push("/h5/login")
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            }).catch(err => {
              if (this.hasH5) {
                this.$router.push("/h5/login")
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            })
          }
        }).catch(err => {
          if (this.hasH5) {
            this.$router.push("/h5/login")
            return;
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        });
        return
      }
      this.$router.push(url);
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", '_blank')
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false
        if (this.hasH5) {
          this.$router.push('/h5/login')
          return
        }
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    },
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style lang="less" scoped>
.view {
  background-color: #f5f5f5;
  text-align: left !important;
}

.downloadClass {
  height: 430px;
  border-radius: 6px;
}

.downloadClass2 {
  height: 317px;
  border-radius: 6px;
}

.down-type {
  float: left;
  margin: 0 25px;
}

.center-tab {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 4%;
  height: 90.5%;
  background-color: whitesmoke;
}

.center-tab-full {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 4%;
  height: 100%;
  background-color: whitesmoke;
}

.downbutton {
  line-height: 0 !important;
  width: 96px !important;
  height: 36px !important;
  background-color: #184482 !important;
  border-color: #184482 !important;
  color: #ffffff !important;
  border-radius: 3px !important;
  margin-left: 29px !important;
}

/deep/ .el-radio__label {
  display: none;
}

.el-button--primarys {
  width: 103px !important;
  height: 40px !important;
  background: #184482 !important;
  border-radius: 3px !important;
  color: #ffffff !important;
  border-color: #184482 !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

.el-button--defaults {
  width: 103px !important;
  height: 38px !important;
  background: #ffffff !important;
  color: #1c50a8 !important;
  border: 1px solid #1c50a8 !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

/deep/ .el-radio {
  margin: 0;
  position: absolute;
}

/deep/ .el-dialog__title {
  width: 278px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}

.onlyorig {
  overflow: hidden;
  width: 48%;
  float: left;
}

.onlytran {
  overflow: hidden;
  width: 48%;
  float: right;
}

.onlyOriginal {
  overflow: hidden;
  width: 48%;
  margin-left: 50%;
  transform: translate(-50%, 0px);
}

.onlyTranslate {
  margin-left: 50%;
  transform: translate(-50%, 0px);
  overflow: hidden;
  width: 48%;
}

.original {
  width: 101.9%;
  float: left;
  overflow: auto;
  position: inherit;
  height: calc(80vh);

  span {
    position: inherit;
  }
}

.originalfull {
  width: 101.9%;
  float: left;
  overflow: auto;
  position: inherit;
  height: calc(93vh);

  span {
    position: inherit;
  }
}

.translate {
  width: 101.9%;
  overflow: auto;
  position: inherit;
  height: calc(80vh);

  span {
    position: inherit;
  }
}

.translatefull {
  width: 101.9%;
  overflow: auto;
  position: inherit;
  height: calc(93vh);

  span {
    position: inherit;
  }
}

/deep/ .el-input__inner:hover {

}

/deep/ .el-input__inner {
  height: 30px !important;
  line-height: 1;
  margin-top: 11px;
}

.pdf-tab {
  margin-top: 500%;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
}

.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }

    }
  }

  .read-main-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;

    div {
      width: 704px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .read-main-lang {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;

    .read-main-lang-content {
      width: 704px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div:nth-child(2) {
        width: 135px;
        height: 44px;
        background: rgba(28, 80, 167, 1);
        border: 1px solid #1C50A7;
        border-radius: 3px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .read-main {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    .read-main-org {
      width: 704px;
      height: 480px;
      background: #FFFFFF;
      box-shadow: 0px 5px 5px 0px rgba(3, 27, 63, 0.1);
      overflow: auto;
    }

    .read-main-tra {
      width: 704px;
      height: 480px;
      background: #FFFFFF;
      box-shadow: 0px 5px 5px 0px rgba(3, 27, 63, 0.1);
      overflow: auto;
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 36px;
    }
  }
}

</style>

<style lang="less" scoped>
@media (max-width: 768px) {
  .main-index {
    width: 100%;
    min-width: 0;
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .read-main-title,
  .read-main-lang {
    margin: 12px 0;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .read-main-title > div,
  .read-main-lang-content {
    width: 100% !important;
    min-width: 0;
    font-size: 15px !important;
  }

  .read-main-lang-content {
    gap: 12px;
  }

  .read-main-lang-content > div:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .read-main-lang-content > div:nth-child(2) {
    width: auto !important;
    height: 36px !important;
    flex: 0 0 auto;
    padding: 0 14px;
    font-size: 14px !important;
    box-sizing: border-box;
  }

  .read-main {
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
  }

  .read-main-org,
  .read-main-tra {
    width: 100% !important;
    max-width: 100%;
    height: 58vh !important;
    max-height: 620px;
    min-height: 320px;
  }

  .read-main img[width="705"] {
    width: 100% !important;
    height: auto;
    display: block;
  }

  /deep/ .el-dialog {
    width: calc(100vw - 24px) !important;
    max-width: 555px;
  }

  /deep/ .el-dialog__body {
    padding: 16px 12px 24px;
  }

  .downloadClass,
  .downloadClass2 {
    width: 100%;
    height: auto !important;
    min-height: 300px;
    box-sizing: border-box;
  }

  .downloadClass {
    min-height: 430px;
  }

  .read-download-heading,
  .read-download-subheading {
    width: 100% !important;
    margin: 0 0 22px !important;
    font-size: 16px !important;
  }

  .read-download-formats {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 18px 12px;
    margin: 0 !important;
  }

  .read-download-formats .down-type {
    width: 54px;
    margin: 0 !important;
    float: none;
  }

  .read-download-actions {
    position: static !important;
    display: flex;
    justify-content: center;
    margin-top: 24px;
    transform: none !important;
  }

  .read-download-progress-state > div:first-child img {
    width: 100% !important;
    max-width: 330px;
    height: auto !important;
  }

  .read-download-progress-state > div:nth-child(2) {
    width: 100% !important;
    height: auto !important;
    min-height: 48px;
    margin: 0 auto 24px !important;
    transform: none !important;
    font-size: 15px !important;
    line-height: 24px !important;
  }

  .read-download-progress-state > div:nth-child(3) {
    position: static !important;
    transform: none !important;
  }

  /deep/ .read-download-progress-state .el-progress {
    width: 100% !important;
    max-width: 395px;
    margin: 0 auto;
  }
}
</style>
